import { render, staticRenderFns } from "./manage-categories.vue?vue&type=template&id=2e917477&scoped=true&"
import script from "./manage-categories.vue?vue&type=script&lang=js&"
export * from "./manage-categories.vue?vue&type=script&lang=js&"
import style0 from "./manage-categories.vue?vue&type=style&index=0&id=2e917477&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e917477",
  null
  
)

export default component.exports